import {
  isUserAdminInSociety,
  isUserBoardMemberInSociety,
} from '../helpers/society'
import { useAuthenticatedUserId } from './useAuthenticatedUserId'
import { ISocietiesModel } from '../interfaces/models/societies.interfaces'

export const useSocietyLockedForCurrentUser = (
  society: ISocietiesModel | undefined
): boolean => {
  const userId = useAuthenticatedUserId() as string
  const isAdmin = isUserAdminInSociety(society, userId)
  const isBoard = isUserBoardMemberInSociety(society, userId)
  const isAdminOrBoard = isAdmin || isBoard

  if (!society) {
    return false
  }
  return (society.locked && isAdminOrBoard) || false
}
